import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAtomValue } from 'jotai';

import { usePlaylistActions } from './hooks/usePlaylistActions';
import { useWishlistHandling } from './hooks/useWishlistHandling';
import { userInfoAtom } from '../../../data/atoms/utilsAtoms.js';
import MobileViewSearch from '../../../component/MobileViewSearch/index.jsx';
import { useFeaturedPlayListQuery, useGetCombinedVideosByIdQuery } from '../../../service/index.js';
import { AllPlayList } from '../../../component/common/AllPlayList.jsx';
import { PlaylistEditModal } from '../../../component/playlist/personal-playlist/PlaylistEditModal.jsx';
import DeleteModal from '../../../component/playlist/personal-playlist/DeleteModal.jsx';
import DeleteModalPlayList from '../../../component/playlist/personal-playlist/DeleteModalPlayList.jsx';
import checkApiStatus from '../../../component/SubscripStatus.jsx';
import PlaylistContent from './components/PlaylistContent/index.jsx';
import PlaylistHeader from './components/PlaylistHeader/index.jsx';
import playlistApi from '../../../api/playlistApi.js';
import Toast from '../../../utils/toastManager.js';
import UndoModal from '../../components/UndoModal.jsx';
import Spinner from '../../../component/Spinner.jsx';
import { sortVideosByPosition } from '../../../utils/sortVideos.jsx';
import { Playlist } from '@/constants/Playlist';
import { getFeaturedPlayList } from '../../../redux/featuredPlayListSlice';



export const AllPlaylists = () => {
	const dispatch = useDispatch();
	const userData = useAtomValue(userInfoAtom);
	const FPL = useSelector(state => state.featuredPlayListState.featuredPlayList);
	const [index, setIndex] = useState(parseInt(window.location.hash.substring(1)) || 0);
	const { data: APL, refetch: refetchCombinedVideos } = useGetCombinedVideosByIdQuery(userData.user?.userId, {
		skip: !userData.user?.userId
	});
	const currentPlaylist =
		APL && Array.isArray(APL.combinedVideos) && index >= 0 && index < APL.combinedVideos.length
			? APL.combinedVideos[index]
			: Array.isArray(FPL) && index >= 0 && index < FPL.length
				? FPL[index]
				: { type: '', _id: '', name: '', videos: [] };

	const [showModal, setModalShow] = useState(false);
	const [nshowModal, setnModalShow] = useState(false);
	const [editPlaylistID, setEditPlaylistID] = useState('');
	const [modal, setModal] = useState(false);
	const [playlistmodal, setPlaylistmodal] = useState(false);
	const [playListId, setPlayListId] = useState(null);
	const [updatePlayList, setUpdatePlayList] = useState(null);
	const [shuffledData, setShuffledData] = useState([]);
	const [subscriptionStatus, setSubscriptionStatus] = useState(false);
	const [isReordering, setIsReordering] = useState(false);
	const [currentVideos, setCurrentVideos] = useState(sortVideosByPosition(currentPlaylist?.videos) || []);
	const [prevVideos, setPrevVideos] = useState([]);
	const [showUndo, setShowUndo] = useState(false);
	const [isLoading, setLoading] = useState(false)
	const [reorderedPayload, setReorderedPayload] = useState(null);

	const resFeaturedPlayList = useFeaturedPlayListQuery({ token: userData.token ?? '' });
	const combinedVideos = APL?.combinedVideos;
	const data = combinedVideos || FPL;

	useEffect(() => {
		setCurrentVideos(sortVideosByPosition(currentPlaylist?.videos))
	}, [currentPlaylist, isReordering, showUndo])
	// Custom hooks
	const {
		handleDeletePlaylist,
		handleDeleteVideo,
		handleEditPlaylist,
		handleUpdatePlaylist,
		initializePlaylistData,
		refreshPlaylists,
		reqPersonalPlayList,
		resPersonalPlayList,
		resDelete,
		resStudioDelete,
		resPersonalDelete
	} = usePlaylistActions({
		userInfo: userData?.user || null,
		setModal,
		setModalShow,
		setEditPlaylistID,
		setPlayListId,
		setPlaylistmodal,
		setUpdatePlayList,
		setIsReordering
	});

	const { wishListArr, savedVideos, handleWishList, handleSaveUnsave, initializeWishlistData } = useWishlistHandling(
		userData,
		resFeaturedPlayList
	);


	useEffect(() => {
		if (userData.user?.userId) {
			reqPersonalPlayList({ userId: userData.user.userId });
		}
	}, [userData.user?.userId]);

	useEffect(() => {
		if (resFeaturedPlayList?.isSuccess) {
			initializeWishlistData();
		}
	}, [resFeaturedPlayList?.isSuccess]);



	useEffect(() => {
		const checkSubscription = async () => {
			const subStatus = await checkApiStatus(userData.token);
			setSubscriptionStatus(subStatus);
		};
		checkSubscription();
	}, []);

	// Reset shuffled data when index changes
	useEffect(() => {
		setShuffledData([]);
	}, [index]);

	// Refetch data when necessary
	useEffect(() => {
		refetchCombinedVideos();
	}, [
		userData.user?.userId,
		resFeaturedPlayList?.isSuccess,
		index,
		showModal,
		modal,
		nshowModal,
		refetchCombinedVideos,
		userData.token,
		resPersonalPlayList?.isSuccess,
		resDelete?.isSuccess,
		resStudioDelete?.isSuccess,
		resPersonalDelete?.isSuccess,
	]);

	// Handle shuffle
	const saveTimeoutRef = useRef(null);

	const handleShuffle = (e, type,videos) => {
		e.preventDefault();
		const shuffledArray = [...videos];
		for (let i = shuffledArray.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
		}

		setPrevVideos(currentVideos);
		setCurrentVideos(shuffledArray);
		setShuffledData(shuffledArray);
		if(type === Playlist.FPL){
			return;
		}
		setShowUndo(true);

		const reorderedPositions = shuffledArray.map((item, index) => ({
			_id: item._id,
			newPosition: index,
		}));
		const newPayload = {
			type: currentPlaylist?.type,
			playlistId: currentPlaylist?._id,
			reorderedPositions,
		}

		setReorderedPayload(newPayload);
		Toast.showToast(<UndoModal onSave={() => handleSaveOrder(newPayload)} onUndo={handleUndo} />, { duration: 5000 });

	};

	const handleReorderClicked = () => {
		setIsReordering(true)
		setPrevVideos(currentVideos)
	}

	const handleReorder = (next, updates) => {

		const reorderedPositions = updates.map((item, index) => ({
			_id: item.id,
			newPosition: item.newPosition,
		}));

		setCurrentVideos(next);
		setReorderedPayload({
			type: currentPlaylist.type,
			playlistId: currentPlaylist._id,
			reorderedPositions,
		});
	};


	const handleSaveOrder = async (payload = reorderedPayload) => {
		if (payload === undefined || payload === null) {
			Toast.error("Payload is null") 
			setIsReordering(false);
			setShowUndo(false);
			return;
		}

		try {
			setLoading(true);
			const response = await playlistApi.saveNewOrderToBackend(payload);

			await refetchCombinedVideos();
			setIsReordering(false);

			Toast.success("Playlist reordered successfully!");
		} catch (err) {
			Toast.error('Error saving order');
		} finally {
			setLoading(false);
		}
	};


	const handleUndo = async () => {
		setLoading(true);
		clearTimeout(saveTimeoutRef.current);
		setCurrentVideos([...prevVideos]);
		await refetchCombinedVideos()
		window.location.reload();
		setLoading(false)
		setShowUndo(false);
	};

	
	// Modal handlers
	const handleCloseEditModal = () => {
		setModalShow(false);
		initializePlaylistData(resFeaturedPlayList, nshowModal);
	};

	const handleConfirmDeleteVideo = () => {
		if (updatePlayList) {
			handleUpdatePlaylist(updatePlayList);
			setModal(false);
		}
	};

	const handleCancelDeleteVideo = () => {
		setUpdatePlayList(null);
		setModal(false);
	};

	const handleConfirmDeletePlaylist = () => {
		if (playListId) {
			handleDeletePlaylist(playListId, currentPlaylist?.type);
		}
		window.location.hash = '0';
		setPlaylistmodal(false);
	};

	const handleCancelDeletePlaylist = () => {
		setPlayListId(null);
		setPlaylistmodal(false);
	};

	return (
		<>
			{isLoading && <Spinner />}
			<div className="row m-0 update c-mobile_honm-serch">
				<MobileViewSearch />
			</div>

			<div>
				<div className="tab-content">
					<div id="menu2" className="tab-pane fade active show">
						<AllPlayList
							data={data}
							currentIndex={index}
							setCurrentIndex={setIndex}
							page="Playlists"
							nshowModal={nshowModal}
							setnModalShow={setnModalShow}
							handleModalSubmit={() => {
								refreshPlaylists();
							}}
							subscribtionStatus={subscriptionStatus}
							isEditMode={isReordering}
							onDelete={handleDeletePlaylist}
						/>

						<PlaylistEditModal
							showModal={showModal}
							setModalShow={setModalShow}
							handleClose={handleCloseEditModal}
							playlistType={currentPlaylist?.type}
							editPlaylistID={editPlaylistID}
							setnModalShow={setnModalShow}
							nshowModal={nshowModal}
						/>

						<div
							className="c-video c-video_feature-box update updated__play__card__list"
							style={{ backgroundColor: 'var(--dark)' }}
						>
							{currentPlaylist && currentPlaylist._id ? (
								<div className="mt-2 position-relative">
									{/* Playlist Header */}
									<PlaylistHeader
										playlist={currentPlaylist}
										onEdit={handleEditPlaylist}
										onDelete={handleDeletePlaylist}
										onShuffle={handleShuffle}
										onReorderClicked={handleReorderClicked}
										userInfo={userData.user}
										isReordering={isReordering}
										onSave={() => handleSaveOrder()}
									/>

									{/* Playlist Content */}
									<PlaylistContent
										videos={shuffledData.length > 0 ? shuffledData : currentVideos}
										playlist={currentPlaylist}
										wishListArr={wishListArr}
										savedVideos={savedVideos}
										handleWishList={handleWishList}
										handleSaveUnsave={handleSaveUnsave}
										handleDeleteVideo={handleDeleteVideo}
										subscriptionStatus={subscriptionStatus}
										onReorder={handleReorder}
										isReordering={isReordering}

									/>
								</div>
							) : (
								'No Playlist'
							)}
						</div>
					</div>
				</div>
			</div>
			{/* Modals */}
			<DeleteModal modal={modal} onConfirmAction={handleConfirmDeleteVideo} onCancelAction={handleCancelDeleteVideo} />
			<DeleteModalPlayList
				modal={playlistmodal}
				onConfirmAction={handleConfirmDeletePlaylist}
				onCancelAction={handleCancelDeletePlaylist}
			/>
		</>
	);
};
